module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/extras/privacy-policy/privacy-policy.component.css
// module id = ./src/app/extras/privacy-policy/privacy-policy.component.css
// module chunks = main